<template>
  <div id="app" class="dmd-hitlist">
    <section class="search-section">
      <header class="search-header">
        <h1>{{ $t("hitlist.title") }}</h1>
      </header>
      <div v-if="collection['value']" class="search-and-filter">
        <span class="dmd-filter-collection__text"
          >{{ $t("hitlist.collection.text") }}:</span
        >
        <div
          class="search-and-filter__filter-tag-item dmd-filter-collection__item"
          @click="collection = { name: '', value: '' }"
        >
          <button type="button">
            <i class="icon-close" aria-hidden="true"></i
            ><span>{{ collection["name"] }}</span>
          </button>
        </div>
      </div>
      <div class="search-and-filter dmd-search-and-filter">
        <div class="search-and-filter__inner">
          <!-- <form action="#"> -->
          <fieldset>
            <div class="search-field">
              <input
                type="text"
                class="search-field__input main-input"
                :placeholder="$t('hitlist.search.placeholder')"
                v-model="searchTerm"
              />
              <button class="search-field__submit" v-on:click="search">
                <span class="sr-only">{{ $t("hitlist.search.submit") }}</span>
                <i class="icon-loupe" aria-hidden="true"></i>
              </button>
            </div>
          </fieldset>

          <div class="search-and-filter__filter-tags-wrapper">
            <div class="search-and-filter__filter-tags">
              <button
                type="button"
                class="search-and-filter__filters-toggle-button"
                aria-expanded="false"
              >
                <i class="icon-plus" aria-hidden="true"></i>
                <span>{{ $t("hitlist.filter.title") }}</span>
              </button>
              <ol
                class="search-and-filter__filter-tags-list"
                aria-live="polite"
                v-if="$store.state.filterTags"
              >
                <li
                  class="search-and-filter__filter-tag-item "
                  v-for="tag in $store.state.filterTags"
                  :key="tag._id"
                  @click="$store.commit('filterRemoveTag', tag)"
                >
                  <button type="button">
                    <i class="icon-close" aria-hidden="true"></i
                    ><span>{{ tag.name }}</span>
                  </button>
                </li>
              </ol>

              <ol
                class="search-and-filter__filter-tags-list"
                aria-live="polite"
                v-if="$store.state.filterActors"
              >
                <li
                  class="search-and-filter__filter-tag-item "
                  v-for="actor in $store.state.filterActors"
                  :key="actor._id"
                  @click="$store.commit('filterRemoveActor', actor)"
                >
                  <button type="button">
                    <i class="icon-close" aria-hidden="true"></i
                    ><span>{{ actor.name }}</span>
                  </button>
                </li>
              </ol>

              <ol
                class="search-and-filter__filter-tags-list"
                aria-live="polite"
                v-if="$store.state.filterMaterials"
              >
                <li
                  class="search-and-filter__filter-tag-item "
                  v-for="material in $store.state.filterMaterials"
                  :key="material._id"
                  @click="$store.commit('filterRemoveMaterial', material)"
                >
                  <button type="button">
                    <i class="icon-close" aria-hidden="true"></i
                    ><span>{{ material.name }}</span>
                  </button>
                </li>
              </ol>

              <ol
                class="search-and-filter__filter-tags-list"
                aria-live="polite"
                v-if="$store.state.filterPlaces"
              >
                <li
                  class="search-and-filter__filter-tag-item "
                  v-for="place in $store.state.filterPlaces"
                  :key="place._id"
                  @click="$store.commit('filterRemovePlace', place)"
                >
                  <button type="button">
                    <i class="icon-close" aria-hidden="true"></i
                    ><span>{{ place.name }}</span>
                  </button>
                </li>
              </ol>
            </div>
          </div>

          <div class="search-and-filter__filters-toggle-panel">
            <fieldset class="research-projects-search__tag-selector">
              <div class="research-projects-search__fieldsets-wrapper">
                <search-filter-list
                  :itemsDisplay="displayTags"
                  :checkedItems="$store.state.filterTags"
                  :title="$t('hitlist.filter.tag.title')"
                  :placeholder="$t('hitlist.filter.tag.placeholder')"
                  @add="$store.commit('filterAddTag', $event)"
                  @remove="$store.commit('filterRemoveTag', $event)"
                  ref="tagSearch"
                />

                <search-filter-list
                  :itemsDisplay="displayActors"
                  :checkedItems="$store.state.filterActors"
                  :title="$t('hitlist.filter.actor.title')"
                  :placeholder="$t('hitlist.filter.actor.placeholder')"
                  @add="$store.commit('filterAddActor', $event)"
                  @remove="$store.commit('filterRemoveActor', $event)"
                  ref="actorSearch"
                />

                <search-filter-list
                  :itemsDisplay="displayMaterials"
                  :checkedItems="$store.state.filterMaterials"
                  :title="$t('hitlist.filter.material.title')"
                  :placeholder="$t('hitlist.filter.material.placeholder')"
                  @add="$store.commit('filterAddMaterial', $event)"
                  @remove="$store.commit('filterRemoveMaterial', $event)"
                  ref="materialSearch"
                />

                <search-filter-list
                  :itemsDisplay="displayPlaces"
                  :checkedItems="$store.state.filterPlaces"
                  :title="$t('hitlist.filter.place.title')"
                  :placeholder="$t('hitlist.filter.place.placeholder')"
                  @add="$store.commit('filterAddPlace', $event)"
                  @remove="$store.commit('filterRemovePlace', $event)"
                  ref="placeSearch"
                />

                <div class="dmd-filter-date">
                  <label for="filter_date_from"
                    >{{ $t("hitlist.filter.date.from.title") }}:</label
                  >
                  <input
                    type="text"
                    class=""
                    id="filter_date_from"
                    :placeholder="$t('hitlist.filter.date.from.placeholder')"
                    maxlength="4"
                    v-model="filterByEarliestDate"
                  />
                  <label for="filter_date_to"
                    >{{ $t("hitlist.filter.date.to.title") }}:</label
                  >
                  <input
                    type="text"
                    class=""
                    id="filter_date_to"
                    :placeholder="$t('hitlist.filter.date.to.placeholder')"
                    maxlength="4"
                    v-model="filterByLatestDate"
                  />
                </div>
              </div>
            </fieldset>
          </div>

          <div class="filter-container dmd-filter-container">
            <span>{{ $t("hitlist.filter.scope.only_in") }}</span>
            <div class="checkbox dmd-checkbox">
              <label for="collection-filter">
                <input
                  class="checkbox__input"
                  id="collection-filter"
                  type="checkbox"
                  v-model="filterCollection"
                />
                <span class="checkmark" aria-hidden="true"></span>
                {{ $t("hitlist.filter.scope.collection") }}
              </label>
            </div>

            <div class="checkbox dmd-checkbox">
              <label for="library-filter">
                <input
                  class="checkbox__input"
                  id="library-filter"
                  type="checkbox"
                  v-model="filterLibrary"
                />
                <span class="checkmark" aria-hidden="true"></span>
                {{ $t("hitlist.filter.scope.library") }}
              </label>
            </div>

            <div class="checkbox dmd-checkbox">
              <label for="archive-filter">
                <input
                  class="checkbox__input"
                  id="archive-filter"
                  type="checkbox"
                  v-model="filterArchive"
                />
                <span class="checkmark" aria-hidden="true"></span>
                {{ $t("hitlist.filter.scope.archive") }}
              </label>
            </div>
          </div>

          <div class="filter-container dmd-filter-container">
            <app-dropdown
              :title="$t('hitlist.order.order_by')"
              :init="this.orderByField"
              :options="sortingOptions"
              name="sorting"
              @change="updateSorting"
              style="float: left;"
            />

            <div class="dmd-checkbox--right">
              <div class="checkbox dmd-checkbox">
                <label for="order-direction">
                  <input
                    class="checkbox__input"
                    id="order-direction"
                    type="checkbox"
                    v-model="orderDirection"
                  />
                  <span class="checkmark" aria-hidden="true"></span>
                  {{ $t("hitlist.order.order_direction") }}
                </label>
              </div>

              <div class="checkbox dmd-checkbox">
                <label for="object-with-image">
                  <input
                    class="checkbox__input"
                    id="object-with-image"
                    type="checkbox"
                    v-model="hasMedia"
                  />
                  <span class="checkmark" aria-hidden="true"></span>
                  {{ $t("hitlist.filter.image") }}
                </label>
              </div>

              <div class="reset-wrapper dmd-checkbox">
                <button
                  class="button--reset dmd-button--reset"
                  v-on:click="resetFilter"
                >
                  <i class="icon-reset" aria-hidden="true"></i>
                  <span>{{ $t("hitlist.filter.reset") }}</span>
                </button>
              </div>
            </div>
          </div>
          <!-- </form> -->
          <div class="result-count-container dmd-result-count-container">
            <p class="dmd-result-count" v-if="$apollo.loading">
              {{ $t("hitlist.results.loading") }}
            </p>
            <p class="dmd-result-count" v-else>
              {{ searchResultsCount }} {{ $t("hitlist.results.title") }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <section
      class="teaser-objects dmd-result-section"
      aria-label="Liste der Suchergebnisse"
    >
      <div class="teaser-objects--wrapper col-3">
        <div
          class="teaser-objects--item"
          v-for="(result, index) in searchResults"
          :key="index + '-' + result.title"
        >
          <figure
            class="ce-media"
            itemscope="itemscope"
            itemtype="https://schema.org/ImageObject"
            data-lightbox
          >
            <picture data-lazerload v-if="result.media !== null">
              <a :href="getUrl(result)">
                <img
                  alt="placeholder"
                  itemprop="image"
                  data-size="395x395"
                  :src="resultMediaUrl(result.media)"
                />
              </a>
            </picture>
            <span
              class="gallery-placeholder"
              :style="resultMediaSize(result.media)"
            ></span>

            <figcaption class="dmd-result">
              <a :href="getUrl(result)"
                ><p class="dmd-result__title" itemprop="description">
                  {{ resultTitle(result.title) }}
                </p></a
              >
              <p class="dmd-result__description" itemprop="description">
                {{ $t("hitlist.results.result.from") }}:
                {{ resultActors(result.actors) }}
              </p>
              <!-- archive: if date is empty display duration -->
              <p class="dmd-result__description" itemprop="description" v-if="result.objectType.__typename == 'ArchiveUnitNode' || result.objectType.__typename == 'ArchiveItemNode' && result.dateVerbose !== null">
                {{ $t("hitlist.results.result.date") }}:
                {{ resultDate(result.dateVerbose) }}
              </p>
              <p class="dmd-result__description" itemprop="description" v-else>
                {{ $t("hitlist.results.result.duration") }}:
                {{ resultDate(result.duration) }}
              </p>
              <p class="dmd-result__description" itemprop="description" v-if="result.objectType.__typename == 'ArchiveUnitNode' || result.objectType.__typename == 'ArchiveItemNode'">
                {{ $t("hitlist.results.result.signature") }}:
                {{ resultIdentifier(result.identifier) }}
              </p>
            </figcaption>
          </figure>
        </div>
      </div>

      <!-- loading -->
      <div
        class="animation-box"
        style="position: unset;"
        v-if="$apollo.loading"
      >
        <div class="loader">
          <svg class="circular" viewBox="25 25 50 50">
            <circle
              class="path"
              cx="50"
              cy="50"
              r="20"
              fill="none"
              stroke-width="2"
              stroke-miterlimit="10"
              style="stroke: black;"
            />
          </svg>
        </div>
      </div>

      <button
        href=""
        class="button"
        v-on:click="loadMore"
        v-if="this.searchResultsCount > this.searchResults.length"
      >
        {{ $t("hitlist.results.load_more") }}
      </button>
    </section>
  </div>
</template>

<script>
import gql from "graphql-tag";
import SearchFilterList from "./components/SearchFilterList.vue";
import Dropdown from "./components/Dropdown.vue";

export default {
  name: "App",
  data() {
    return {
      searchTerm: "",
      hasMedia: false,
      orderByField: "score",
      orderDirection: true,
      collection: {
        name: "",
        value: "",
      },

      filterByEarliestDate: "",
      filterByLatestDate: "",

      filterCollection: true,
      filterLibrary: true,
      filterArchive: true,

      displayTags: [],
      displayActors: [],
      displayMaterials: [],
      displayPlaces: [],

      searchResults: [],
      searchResultsCount: 0,

      initialLoading: true,
      refetchEmptySearchTerm: false,
      limit: 25,
      page: 0,

      sortingOptions: [
        { id: "score", title: this.$t("hitlist.order.option.score") },
        { id: "title", title: this.$t("hitlist.order.option.title") },
        { id: "date", title: this.$t("hitlist.order.option.date") },
        { id: "identifier", title: this.$t("hitlist.order.option.identifier") },
        { id: "tag", title: this.$t("hitlist.order.option.tag") },
        { id: "actor", title: this.$t("hitlist.order.option.actor") },
        { id: "place", title: this.$t("hitlist.order.option.place") },
      ],

      paramTags: [],
      paramActors: [],
      paramMaterials: [],
      paramPlaces: [],
    };
  },
  methods: {
    updateSorting: function(value) {
      this.orderByField = value;
    },
    search: function() {
      this.page = 0;
      this.$apollo.queries.searchObjects.refetch();
    },
    resetFilter: function() {
      this.$store.dispatch("resetFilters");
      this.hasMedia = false;
      this.orderByField = "score";
      this.orderDirection = true;

      this.filterByEarliestDate = "";
      this.filterByLatestDate = "";

      this.filterCollection = true;
      this.filterLibrary = true;
      this.filterArchive = true;

      this.$refs.tagSearch.resetSearch();
      this.$refs.actorSearch.resetSearch();
      this.$refs.materialSearch.resetSearch();
      this.$refs.placeSearch.resetSearch();
    },
    loadMore: function() {
      this.page++;

      this.$apollo.queries.searchObjects.fetchMore({
        variables: {
          offset: this.limit * this.page,
        },
        updateQuery: (existing, incoming) => {
          this.searchResults = [
            ...this.searchResults,
            ...incoming.fetchMoreResult.searchObjects.results,
          ];

          // update search result grid
          var event = new Event("resize");
          setTimeout(function() {
            window.dispatchEvent(event);
          }, 100);
        },
      });
    },
    getUrl(item) {
      switch (item.objectType.__typename) {
        case "CollectionObjectNode":
          return window.urlCollectionObject.replace(
            "0",
            encodeURIComponent(item.identifier)
          );
        case "LibraryObjectNode":
          return window.urlLibraryObject.replace(
            "0",
            encodeURIComponent(item.identifier)
          );
        case "ArchiveUnitNode":
          return window.urlArchiveUnit.replace(
            "0",
            encodeURIComponent(item.identifier)
          );
        case "ArchiveItemNode":
          return window.urlArchiveItem.replace(
            "0",
            encodeURIComponent(item.identifier)
          );
        default:
          return ".";
      }
    },
    resultIdentifier(identifier) {
      if (identifier == null) {
        return "-";
      } else {
        return identifier;
      }
    },
    resultTitle(title) {
      if (title == null) {
        return this.$t("hitlist.results.result.missing_title");
      } else {
        return title;
      }
    },
    resultActors(actors) {
      if (actors == null) {
        return "-";
      } else if (actors.length <= 5) {
        return actors.join("; ");
      } else {
        return actors.slice(0, 5).join("; ") + "; ...";
      }
    },
    resultDate(dateVerbose) {
      if (dateVerbose == null) {
        return "-";
      }
      return dateVerbose;
    },
    resultMediaUrl(media) {
      if (media == null) {
        return null;
      } else {
        return media[0].path + "/full/395,/0/default.jpg";
      }
    },
    resultMediaSize(media) {
      if (media == null) {
        return "";
      }
      var ratio = media[0].ratio;
      var padding = Math.floor(ratio * 100).toString();
      return "padding-top: " + padding + "%;";
    },
  },
  created() {
    var qs = require("qs");
    var params = qs.parse(document.location.search.substring(1), {
      comma: true,
    });

    // searchTerm
    var searchTerm = params["searchTerm"] || "";
    var q = params["q"] || "";
    if (searchTerm) {
      this.searchTerm = searchTerm;
    } else if (q) {
      this.searchTerm = q;
    }

    // filter options
    this.hasMedia = (params["hasMedia"] || "false") === "true";
    var orderByField = params["orderByField"];
    if (
      [
        "score",
        "title",
        "date",
        "identifier",
        "tag",
        "actor",
        "place",
      ].includes(orderByField)
    ) {
      this.updateSorting(orderByField);
    }
    this.orderDirection = (params["orderDirection"] || "true") === "true";

    if (Array.isArray(params["filterCollection"])) {
      params["filterCollection"] = params["filterCollection"].pop();
    }
    this.filterCollection = (params["filterCollection"] || "true") === "true";

    if (Array.isArray(params["filterLibrary"])) {
      params["filterLibrary"] = params["filterLibrary"].pop();
    }
    this.filterLibrary = (params["filterLibrary"] || "true") === "true";

    if (Array.isArray(params["filterArchive"])) {
      params["filterArchive"] = params["filterArchive"].pop();
    }
    this.filterArchive = (params["filterArchive"] || "true") === "true";

    // tags
    if (Array.isArray(params["tags"]) === false) {
      params["tags"] = [params["tags"]];
    }
    this.paramTags = params["tags"];

    // actors
    if (Array.isArray(params["actors"]) === false) {
      params["actors"] = [params["actors"]];
    }
    this.paramActors = params["actors"];

    // materials
    if (Array.isArray(params["materials"]) === false) {
      params["materials"] = [params["materials"]];
    }
    this.paramMaterials = params["materials"];

    // place
    if (Array.isArray(params["places"]) === false) {
      params["places"] = [params["places"]];
    }
    this.paramPlaces = params["places"];

    // collection
    if (
      typeof params["collection"] === "object" &&
      params["collection"] !== null
    ) {
      if (!("name" in params["collection"])) {
        this.collection = {
          name: params["collection"]["value"],
          value: params["collection"]["value"],
        };
      } else {
        this.collection = params["collection"];
      }
    } else {
      var value = params["collection"] || "";
      this.collection = {
        name: value,
        value: value,
      };
    }
  },
  components: {
    SearchFilterList,
    AppDropdown: Dropdown,
  },
  apollo: {
    searchObjects: {
      query: gql`
        query(
          $limit: Int
          $offset: Int
          $searchTerm: String
          $collection: String
          $hasMedia: Boolean
          $orderByField: String
          $orderDirection: Boolean
          $tags: [String]
          $actors: [String]
          $materials: [String]
          $places: [String]
          $objectType: [String]
          $filterByEarliestDate: String
          $filterByLatestDate: String
        ) {
          searchObjects(
            limit: $limit
            offset: $offset
            searchTerm: $searchTerm
            hasMedia: $hasMedia
            orderByField: $orderByField
            orderDirection: $orderDirection
            filterByCollection: $collection
            filterByTag: $tags
            filterByActor: $actors
            filterByMaterial: $materials
            filterByPlace: $places
            filterByObjectType: $objectType
            filterByEarliestDate: $filterByEarliestDate
            filterByLatestDate: $filterByLatestDate
          ) {
            metaInformation {
              totalCount
              resultCount
              tags {
                name: tagValue
                facetCount
                _id
              }
              actors {
                name: actorName
                facetCount
                _id
              }
              materials {
                name: materialName
                facetCount
                _id
              }
              places {
                name: placeName
                facetCount
                _id
              }
            }
            results {
              identifier
              title
              dateVerbose
              duration
              media {
                path
                ratio
              }
              actors
              objectType {
                __typename
              }
            }
          }
        }
      `,
      // deep: true,
      variables() {
        // filter by object type
        var objectType = [];
        if (this.filterCollection) {
          objectType.push("collection");
        }
        if (this.filterLibrary) {
          objectType.push("library");
        }
        if (this.filterArchive) {
          objectType.push("archive_unit", "archive_item");
        }

        // filter by date
        var filterByEarliestDate = "";
        if (this.filterByEarliestDate.length == 4) {
          filterByEarliestDate = this.filterByEarliestDate;
        }

        var filterByLatestDate = "";
        if (this.filterByLatestDate.length == 4) {
          filterByLatestDate = this.filterByLatestDate;
        }

        return {
          limit: this.limit,
          offset: 0,
          searchTerm: this.searchTerm,
          collection: this.collection["value"],
          hasMedia: this.hasMedia,
          orderByField: this.orderByField,
          orderDirection: this.orderDirection,
          objectType: objectType,
          tags: this.$store.state.filterTags.map((item) => item._id),
          actors: this.$store.state.filterActors.map((item) => item._id),
          materials: this.$store.state.filterMaterials.map((item) => item._id),
          places: this.$store.state.filterPlaces.map((item) => item._id),
          filterByEarliestDate: filterByEarliestDate,
          filterByLatestDate: filterByLatestDate,
        };
      },
      update(data) {
        if (this.searchTerm == "" && this.refetchEmptySearchTerm == false && this.initialLoading == false) {
          this.refetchEmptySearchTerm = true;
          this.$apollo.queries.searchObjects.refetch();
        } else {
          this.initialLoading = false;
          this.refetchEmptySearchTerm = false;
        }

        this.displayTags = data.searchObjects.metaInformation.tags;
        this.displayActors = data.searchObjects.metaInformation.actors;
        this.displayMaterials = data.searchObjects.metaInformation.materials;
        this.displayPlaces = data.searchObjects.metaInformation.places;

        this.searchResults = data.searchObjects.results;
        this.searchResultsCount = data.searchObjects.metaInformation.totalCount;
        this.page = 0;

        // initial tags
        if (this.paramTags) {
          this.paramTags.forEach((item) => {
            const tag = this.displayTags.find(
              (tag) => tag._id == item || tag.name == item
            );

            if (tag) {
              this.$store.commit("filterAddTag", tag);
            }
          });
          this.paramTags = [];
        }

        // initial actors
        if (this.paramActors) {
          this.paramActors.forEach((item) => {
            const actor = this.displayActors.find(
              (actor) =>
                actor._id == item || actor.name.replace(/,/g, "") == item
            );

            if (actor) {
              this.$store.commit("filterAddActor", actor);
            }
          });
          this.paramActors = [];
        }

        // initial materials
        if (this.paramMaterials) {
          this.paramMaterials.forEach((item) => {
            const material = this.displayMaterials.find(
              (material) => material._id == item || material.name == item
            );

            if (material) {
              this.$store.commit("filterAddMaterial", material);
            }
          });
          this.paramMaterials = [];
        }

        // initial places
        if (this.paramPlaces) {
          this.paramPlaces.forEach((item) => {
            const place = this.displayPlaces.find(
              (place) => place._id == item || place.name == item
            );

            if (place) {
              this.$store.commit("filterAddPlace", place);
            }
          });
          this.paramPlaces = [];
        }

        // update search result grid
        var event = new Event("resize");
        setTimeout(function() {
          window.dispatchEvent(event);
        }, 100);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.dmd-hitlist {
  .dmd-filter-collection__text {
    margin-right: 10px;
  }

  .dmd-filter-collection__item {
    display: inline-block;
  }

  .dmd-search-and-filter .options-dropdown-facet {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(25% - 40px);
  }

  .dmd-filter-container {
    display: inline-grid;
    row-gap: 2px;

    width: 100%;
    margin-top: 10px;
    margin-bottom: 0px;
    margin-left: 5px;

    @media (min-width: 498px) {
      display: inline-block;
      margin-left: 0px;
    }
  }

  .dmd-filter-date {
    display: inline-block;
    width: 100%;
    margin-top: 15px;
    margin-bottom: 0px;

    border-top: 2px solid var(--c-black);
    //-top: 25px;

    label {
      margin-right: 5px;
    }

    input {
      width: 60px;
      color: #000;
      background: #d9d9d9;
      border-radius: 5px;
      padding: 5px;
      font-size: 100%;
      font-family: inherit;
      line-height: 1.15;

      margin-top: 10px;
      margin-right: 10px;
      margin-bottom: 10px;

      @media (min-width: 768px) {
        margin-bottom: 0px;
        margin-top: 25px;
      }
    }

    input::placeholder {
      color: #000;
      opacity: 1;
    }
  }

  .dmd-checkbox {
    display: inline;
    margin: 0;
    margin-left: 0px;

    @media (min-width: 498px) {
      margin-left: 20px;
    }

    &--right {
      display: inline-grid;
      row-gap: 2px;

      @media (min-width: 498px) {
        float: right;
        display: inline-block;
        margin-left: 0px;
      }
    }
  }

  .dmd-button--reset {
    span {
      margin-left: 5px;
    }

    &:hover {
      i {
        color: black;
      }
    }
  }

  .dmd-result-count-container {
    font-weight: 500;
    font-size: 2rem;
    line-height: calc(45 / var(--font-size) * 1rem);

    display: inline-block;
    margin-top: 80px;

    @media screen and (max-width: 992px) {
      margin-top: 40px;
      font-size: 1.8rem;
    }

    @media screen and (max-width: 767px) {
      margin-top: 25px;
      font-size: 1.5rem;
    }
  }

  .dmd-result-count {
    padding-left: 0;
    margin-top: 0;
  }

  .dmd-result-section {
    margin-top: 65px;

    @media screen and (max-width: 992px) {
      margin-top: 45px;
    }

    @media screen and (max-width: 767px) {
      margin-top: 25px;
    }
  }

  .dmd-result {
    margin-top: 15px;
    color: #000000;
    font-family: "Futura PT";
    letter-spacing: 0;
    overflow: hidden;

    &__title {
      font-size: 21px;

      @media (min-width: 641px) {
        font-size: 25px;
      }
      @media (min-width: 1025px) {
        font-size: 30px;
      }

      font-weight: 500;
      line-height: 35px;
    }

    &__description {
      font-size: 18px;

      @media (min-width: 641px) {
        font-size: 20px;
      }

      line-height: 27px;
    }
  }
}
</style>
